import axios from 'axios';

const api = axios.create({ baseURL: 'https://restaurant-backend-pi-nine.vercel.app/api' });

export default api;
